import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import User from 'entity/User'
import React, { useEffect, useState } from 'react'
import { exportCsv } from 'functions'
import { useAppContext } from 'app/AppContext'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'

export default function UsuarioConsulta() {
    const navigate = useNavigate();
    const { setActionsView } = useAppContext();
    const [usuarios, setUsuarios] = useState([])

    useEffect(() => {
        const actions = [
            {
                uid: "novoFormUser",
                text: "Criar Usuário",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/_cadastro-usuario");
                },
            },
            {
                uid: "exportCsv",
                text: "Exportar",
                iconName: "GetApp",
                sequence: "20",
                action: () => {
                    let conf = [
                        { labelCol: "Nome", getValue: (l) => l.nome },
                        { labelCol: "Email", getValue: (l) => l.email },
                        { labelCol: "Status", getValue: (l) => l.status },
                        { labelCol: "Grupo Permissao", getValue: (l) => l.grupoPermissao?.nome },
                        { labelCol: "APP_VERSION", getValue: (l) => l.login_version ? "v.: " + l.login_version : "" },
                        {
                            labelCol: "Último Acesso", getValue: (l) => {
                                let date = l.lastLogin
                                if (date) {
                                    date = date.toDate()
                                    date = format(date, "dd/MM/yyy HH:mm");
                                    return date
                                }
                                return ""
                            }
                        },
                    ]
                    exportCsv(conf, usuarios.filter(u => u.email), "Lista de Usuários")
                },
            },
        ];
        setActionsView(actions);
        return () => {
            setActionsView([]);

        };
    }, [navigate, setActionsView, usuarios]);


    // eslint-disable-next-line no-unused-vars
    const deletarSemEmail = () => {
        console.log('deletarSemEmail totdos', usuarios)

        usuarios.forEach(u => {
            let novoStatus = null
            if (u.status === "ATIVO") {
                if (!u.email) {
                    console.log('sem email', u)
                    novoStatus = 'DELETAR'
                }
                //     let axo = mapNewStatus[u.email]
                //     if (!axo) {
                //         console.log('nao axo', u)
                //     }
            }
            // if (u.uid.length < 25 && u.status==="ATIVO") {
            //     console.log('u.uid',u.uid)
            //     console.log('u.nome',u.nome)
            //     // novoStatus = 'DELETAR'
            // }
            if (novoStatus) {

                let entity = new User()

                entity.update({ uid: u.uid, status: novoStatus });

                entity.save().then(() => { })
            }
        });
    }

    return (
        <DefaultEntityConsult
            EntityClass={User}
            initialFilters={{ status: "ATIVO" }}
            titulo="Usuários"
            routeForm="_usuario"
            routeCreate="_cadastro-usuario"
            onFilteredValues={setUsuarios}
            showEdit={true}
            showDelete={true}
        />
    )
}
